export const CoupleSession = [
  { id: 1, name: "AB", title: "A & B", caption: "7 Aug 2022", img: require("./img/slider/wecoffee.webp") },
  { id: 2, name: "CD", title: "C & D", caption: "1 July 2022", img: require("./img/slider/Advance1.webp") },
  { id: 3, name: "XY", title: "X & Y", caption: "10 Jan 2015", img: require("./img/slider/IMONO1.webp") },
];

export default CoupleSession;
